import z from "zod";
import { BaseSchema, PaginationSchema, SortSchema } from "../common";

const CitySchema = z.object({
  ...BaseSchema.shape,
  slug: z.string(),
  nameEn: z.string().min(1).max(255),
  nameAr: z.string().min(1).max(255),
  nameTr: z.string().min(1).max(255).catch("Name TR"),
  nameFa: z.string().min(1).max(255).catch("name FA"),
});

export const CitySchemas = {
  list: z.object({
    ...PaginationSchema.shape,
    slug: z.string().optional(),
    sort: z.array(SortSchema).optional(),
  }),

  find: z.object({ id: z.uuidv7() }),

  create: z.object({
    slug: z.string().optional(),
    nameEn: z.string().min(1),
    nameAr: z.string().min(1),
    nameTr: z.string().min(1).catch("Name TR"),
    nameFa: z.string().min(1).catch("name FA"),
  }),

  update: z.object({
    id: z.uuidv7(),
    slug: z.string().optional(),
    nameEn: z.string().min(1),
    nameAr: z.string().min(1),
    nameTr: z.string().min(1).catch("Name TR"),
    nameFa: z.string().min(1).catch("name FA"),
  }),

  delete: z.object({ id: z.uuidv7() }),
};

export type PopulatedCity = z.infer<typeof CitySchema>;
export type CreateCity = z.infer<typeof CitySchemas.create>;
export type UpdateCity = z.infer<typeof CitySchemas.update>;
export type ListCities = z.infer<typeof CitySchemas.list>;
